module.exports = __webpack_public_path__ + "img/144.6cec8331.jpg";